// 利用規約への同意状態はブラウザ単位で保持する。
// localStorageにはbooleanを直接保存できないため、同意済みの場合のみ文字列の'true'を保存する。
const TERMS_AGREEMENT_STORAGE_KEY = 'mdAccepted';

/**
 * 現在のブラウザで利用規約に同意済みかを取得する。
 * キーが存在しない場合や、localStorageを参照できない場合は未同意として扱う。
 */
export const getTermsAccepted = (): boolean => {
  try {
    return localStorage.getItem(TERMS_AGREEMENT_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

/**
 * 利用規約への同意済み状態を保存する。
 * 保存に失敗しても、呼び出し元で保持する現在のセッション中の同意状態は妨げない。
 */
export const storeTermsAcceptance = (): void => {
  try {
    localStorage.setItem(TERMS_AGREEMENT_STORAGE_KEY, 'true');
  } catch {
    // localStorageを利用できない環境では、呼び出し元のメモリ上の状態だけを更新する
  }
};

/**
 * 明示的なログアウト時に同意状態を削除する。
 * セッションタイムアウト時には呼び出さないため、再ログイン後も同意状態が維持される。
 */
export const clearTermsAccepted = (): void => {
  try {
    localStorage.removeItem(TERMS_AGREEMENT_STORAGE_KEY);
  } catch {
    // localStorageを利用できない環境では何もしない
  }
};
